import { render, staticRenderFns } from "./VirtualIntegrationDialog.vue?vue&type=template&id=1b620150"
import script from "./VirtualIntegrationDialog.vue?vue&type=script&lang=js"
export * from "./VirtualIntegrationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports